import { render } from "./AvatarIcon.vue?vue&type=template&id=044f87b8"
import script from "./AvatarIcon.vue?vue&type=script&lang=js"
export * from "./AvatarIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__